import script from "./StepThankYou.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepThankYou.vue?vue&type=script&setup=true&lang=ts"

import "./StepThankYou.vue?vue&type=style&index=0&id=087b41fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087b41fa"]])

export default __exports__